import DashboardLayout from "components/Dashboard/Layout";

const DashboardHome = () => {
  return <DashboardLayout type="admin">admin home</DashboardLayout>;
};

export default DashboardHome;
